import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import axios from '../../../axios';
import * as url from '../../../utils/url';
import { toastContainer } from '../../../utils/toast';
import { HASHTAG_RECIPIENTS_LABEL } from '../../../utils/triviaResultsStrings';

const getInitials = (name) => {
    const parts = (name || '').trim().split(' ').filter((n) => n.length > 0);
    if (parts.length === 0) return '—';
    return parts.map((n) => n[0]).join('').toUpperCase().slice(0, 2);
};

// Phone-only users carry a generated temp_...@exampleemail.com, shown as no email.
const getDisplayEmail = (email) => {
    const value = (email || '').trim();
    if (!value || value.toLowerCase().endsWith('@exampleemail.com')) return '—';
    return value;
};

// bug964: read-only recipient list for one hashtag, fetched fresh on every open
// so it reflects edits made in Account Settings since the drilldown loaded.
const HashtagRecipientsModal = ({ isOpen, toggle, groupId, hashtagLabel }) => {
    const [recipients, setRecipients] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isOpen || !groupId) return;
        let isActive = true;
        setRecipients([]);
        setLoading(true);
        axios.get(url.textifyGetGroupDetails(groupId))
            .then((res) => {
                if (!isActive) return;
                setRecipients((res && res.data && res.data.recipients) || []);
            })
            .catch((err) => {
                console.error('[HashtagRecipientsModal] Fetch recipients error:', err);
                if (isActive) toastContainer('Failed to load recipients.', 'error');
            })
            .finally(() => {
                if (isActive) setLoading(false);
            });
        return () => { isActive = false; };
    }, [isOpen, groupId]);

    let body;
    if (loading) {
        body = <p className="text-center text-muted">Loading...</p>;
    } else if (recipients.length === 0) {
        body = <p className="text-center text-muted">No recipients found.</p>;
    } else {
        body = (
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                    </tr>
                </thead>
                <tbody>
                    {recipients.map((person, idx) => {
                        const personName = person.name || 'Not Registered';
                        return (
                            <tr key={person.userId || idx}>
                                <td>
                                    <div className="uc-sender-col">
                                        <div className="uc-avatar">{getInitials(person.name)}</div>
                                        <span>{personName}</span>
                                    </div>
                                </td>
                                <td className="align-middle">{getDisplayEmail(person.email)}</td>
                                <td className="align-middle">{person.mobileNumber || '—'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                {HASHTAG_RECIPIENTS_LABEL} — #{hashtagLabel}
            </ModalHeader>
            <ModalBody>{body}</ModalBody>
        </Modal>
    );
};

export default HashtagRecipientsModal;
